export const TEST_ACTION = "TEST_ACTION";
export const SAVE_AUDIT_DATA = "SAVE_AUDIT_DATA";
export const UPDATE_ERROR_STATE = "UPDATE_ERROR_STATE";